import { IViewData } from '@barba/core';
import velocityAnimations from '../inits/velocity-animations';
import panelAnimation from '../inits/panel-animation';
import vegetableAnimation from '../inits/vegetable-animation';

export default {
    namespace: 'product-detail-page',

    beforeEnter({ next }: IViewData) {
        panelAnimation.init(next.container);
        vegetableAnimation.init(next.container);
        velocityAnimations.init();
    },

    afterLeave({ current }: IViewData) {
    },
};
